import { Crisp } from 'crisp-sdk-web'

import { env } from '@/config/env'
import { AuthUser__UserFragment as User } from '@/graphql/api/generated'

import { IChatService } from './interfaces'

export class CrispService implements IChatService {
  private isInitialized = false

  constructor() {
    this.isInitialized = true
  }

  init(): void {
    if (env.CRISP_WEBSITE_ID) {
      // Explicit cookie domain prevents "invalid domain" rejection when not on Vercel
      const cookieDomain = env.COOKIE_DOMAIN || window.location.hostname
      Crisp.configure(env.CRISP_WEBSITE_ID, { cookieDomain })
    }
  }

  setUser(user: User): void {
    if (!this.isInitialized || !user?.email) return

    Crisp.user.setEmail(user.email)
    Crisp.user.setNickname(user.fullname)

    if (user.avatar?.contentUrl) {
      Crisp.user.setAvatar(user.avatar.contentUrl)
    }

    if (user.phoneNumber?.nationalNumber) {
      Crisp.user.setPhone(user.phoneNumber.nationalNumber)
    }

    Crisp.session.setData({
      userId: user.id,
      city: user.city,
      country: user.country,
      gender: user.gender,
      language: user.settings?.language,
      circles: user.circleMemberships?.edges
        ?.map((edge) => edge.node!.circle.name)
        .join(', '),
    })
  }

  reset(): void {
    if (!this.isInitialized) return
    Crisp.session.reset()
  }

  toggle(state?: 'open' | 'close'): void {
    if (!this.isInitialized) return

    if (state === 'open') {
      Crisp.chat.open()
    } else if (state === 'close') {
      Crisp.chat.close()
    } else if (Crisp.chat.isChatOpened()) {
      Crisp.chat.close()
    } else {
      Crisp.chat.open()
    }
  }
}
